import { Box, Button, Container, Divider, Stack, Typography } from '@mui/material';
import Iconify from '../../../../../../components/iconify';
import { useLocales } from '../../../../../../locales';
import { ComponentTypeProps } from '../../../../../../types/page-generator';
import { ActionTypes, useAppContext } from '../../../../../../contexts/AppContext';

export default function CryptoCardInformation({ block }: ComponentTypeProps) {
  const { state, dispatch } = useAppContext();
  const { currentLang } = useLocales();
  const setActiveDialog = (payload: null | string) => {
    dispatch({ type: ActionTypes.SET_ACTIVE_DIALOG, payload });
  };
  return (
    <Box
      sx={{
        mt: 3,
        p: 2,
        // background: '#202D36',
        color: 'black',
        // borderRadius: '20px',
      }}
    >
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 3 }}
      >
        <Typography variant="h6" sx={{ color: 'black' }}>
          Card Info
        </Typography>
        <Iconify
          icon="material-symbols:close-rounded"
          onClick={() => setActiveDialog(null)}
          sx={{ cursor: 'pointer' }}
        />
      </Stack>
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Transaction Fee</Typography>
        <Typography>0.20</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Card Currency</Typography>
        <Typography>$ USD</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Card Type</Typography>
        <Typography>Virtual</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Issuing Fee</Typography>
        <Typography>0</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Consumption Method</Typography>
        <Typography>Debit</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>First Recharge Amount</Typography>
        <Typography>5.00 USD</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Minimum Recharge Amount</Typography>
        <Typography>52.00 USD</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Maximum Recharge Amount</Typography>
        <Typography>10,000.00 USD</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Spending Limit</Typography>
        <Typography>Unlimited</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Minimum Cancellation Fee</Typography>
        <Typography>$ 1.00</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Maximum Cancellation Fee</Typography>
        <Typography>$ 0.00</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Review Time</Typography>
        <Typography>Within 24 hours</Typography>
      </Stack>
      <Divider
        sx={{
          borderStyle: 'dashed',
          borderColor: 'rgba(255,255,255,0.3)', // или другой цвет
          my: 1,
        }}
      />
      <Stack
        direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography>Supported Platforms</Typography>
        <Typography>Apple Pay, Google Pay</Typography>
      </Stack>
    </Box>
  );
}
